import { useCallback, useState } from 'react'
import { csv } from '@scoir/api'
import { ResultOptions, APIFilters } from './types'
import { createURLSeachParamsFromAPIFilters } from '../filter-state-to-api-query'

interface Column {
  field: string
  heading: string
}

interface RequestBody {
  columns: Column[]
}

export default function useExportHighschoolsExplore() {
  const [isLoading, setIsLoading] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [isError, setIsError] = useState(false)
  const [data, setData] = useState<string | null>(null)
  const [error, setError] = useState<unknown>(null)

  const reset = useCallback(() => {
    setIsSuccess(false)
    setIsLoading(false)
    setIsError(false)
    setError(null)
  }, [])

  const mutate = useCallback(
    async ({
      resultOptions,
      filters,
      columns,
    }: {
      resultOptions: ResultOptions
      filters: APIFilters
      columns: Column[]
    }) => {
      reset()
      setIsLoading(true)

      const params = createURLSeachParamsFromAPIFilters(filters)
      params.set('from', (resultOptions.from || 0).toString())
      params.set('limit', resultOptions.limit.toString())
      params.set('sort', resultOptions.sortKey)
      params.set('sortDir', resultOptions.sortDirection)

      const url = `/api/highschools/explore?${params.toString()}`

      try {
        const response = await csv.post<RequestBody>(url, {
          columns,
        })
        setData(response)
        setIsLoading(false)
        setIsSuccess(true)
      } catch (e) {
        setIsLoading(false)
        setIsError(true)
        setError(e)
        setIsSuccess(false)
      }
    },
    [reset],
  )

  return { isLoading, isSuccess, isError, error, data, mutate, reset }
}
